import userLogConf from "./user_log";
import BaseSelect from "@/views/crud/modules/BaseSelect";

export default {
  key: "user_profile",
  // trash: true,
  disabled_by_column:{edit:[]},
  fields: [
    { key: "id" },
    { key: "name", rules: ["required"], disabled_by_column:false },
    { key: "role_id", field: "roles.name_chi", type: "select", rules: ["required"], disabled_by_column:true },
    { key: "username", rules: ["required"], disabled_by_column:true },
    { key: "email" },
    { key: "password", hidden: ["read", "list"], password: true, protected: true, rules: ["required", "not-required-in-edit"] },
    { key: "confirm_password", hidden: ["read", "list"], password: true, protected: true, rules: ["required", "not-required-in-edit"] },
    { key: "active", type: "boolean", disabled_by_column:true },
    { key: "cp_loc_flag", type: "boolean", disabled_by_column:true },
    { key: "loc_id", type:"componentColumn", component:BaseSelect, filterable:true, optionKey: "cp_locs", setup:{label:'label',value:'value'}, disabledFun:d=>d.cp_loc_flag==1, hidden: ["list"], disabled_by_column:true},
    { type: "action-btn" }
    // { key: "password" },
  ],
  structure: [
    ["name","role_id"],
    ["username"],
    ["email"],
    ["password"],
    ["confirm_password"],
    // ["active"],
    // ["cp_loc_flag"],
    // ["loc_id"]
  ],
  action: ["create","edit","view","delete"],
  options: {
    role_id: {
      key: "roles",
      label: "name_chi",
      value: "id"
    },
    loc_id: {
      key: "cp_locs",
      label: "address",
      value: "loc_id"
    },
  },
  default: {
    active: 1
  },
  view: [
    ["id"],
    ["name",{ key: "role_id", type: "array", field: "roles", value: "name_chi" }],
    ["username"],
    ["email"],
    [{ key: "active", type: "boolean" }],
    [{
      type: "tabs",
      items: [
        {
          // type: "related_info",
          key: "user_log",
          params: ["username"],
          name: "user_log",
          ...userLogConf
        }
      ]
    }]
  ]
}